/* eslint-disable class-methods-use-this */
import BaseService from '../base';
import {
  QrCodeEmailParams, QrCodeProps, QrCodesApiProps,
} from './types';

class QrCode extends BaseService {
  getCodesByWorker() {
    return {
      query: (id: number) => ({
        url: `workers/${id}/qr-codes`,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result?: QrCodesApiProps) => [{ type: this.tagType }],
    };
  }

  getHistoryCodesByWorker() {
    return {
      query: (id: number) => ({
        url: `workers/${id}/qr-codes/history`,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result?: QrCodesApiProps) => [{ type: this.tagType }],
    };
  }

  sendEmail() {
    return {
      query: ({ workerId, ...params }: QrCodeEmailParams) => ({
        url: `workers/${workerId}/qr-codes/emails`,
        method: 'POST',
        body: params,
      }),
    };
  }

  createQrCode() {
    return {
      query: ({ workerId, ...params }: QrCodeProps) => ({
        url: `workers/${workerId}/qr-codes`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }, { type: 'Worker' }, { type: 'QrCode' }],
    };
  }
}

export default new QrCode('qrcodes', 'QrCode');
